<template>

	<section class="col-7 margin-b-100 order" v-if="order">

		<header class="header margin-b-50 padding-b-50 border-b">

			<h1>Betaling</h1>

			<p>Nedenfor finder du oplysningerne du har angivet i din bestilling.
				Vi beder dig gennemgå disse nøje, således at du sikrer dig, disse er korrekte.</p>

		</header>

		<section class="col-12 content margin-b-75 padding-b-75 border-b">

			<section class="col-12 margin-b-50">

				<h1>Dine oplysninger</h1>
				<ul>
                    <li v-if="order.information.company_name">{{order.information.company_name}}</li>
                    <li v-if="order.information.cvr">CVR: {{order.information.cvr}}</li>
                    <li v-if="order.information.ean">EAN: {{order.information.ean}}</li>
					<li>{{order.information.firstname}} {{order.information.lastname}}</li>
					<li>{{order.information.address}}</li>
					<li>{{order.information.zipcode}} {{order.information.city}}</li>
					<li>{{order.information.phone}}</li>
					<li>{{order.information.email}}</li>
				</ul>

			</section>

			<section class="col-12 margin-b-50" v-if="order.information.notes">

				<h1>Bemærkninger til ordren</h1>
				<p>{{order.information.notes}}</p>

			</section>


			<section class="col-12 margin-b-50" v-if="order.delivery.with_delivery">

                <h1 v-if="!order.delivery.information.address">Leveringsadresse</h1>
                <h1 v-else>Alternativ leveringsadresse</h1>

				<ul v-if="!order.delivery.information.address">
					<li>{{order.information.address}}</li>
					<li>{{order.information.zipcode}} {{order.information.city}}</li>
					<li>Dato: {{order.delivery.deliver_at | moment('DD-MM-YYYY')}}</li>
                    <li>Tidspunkt: Kl. {{timeSpanTextFromDate(order.delivery.deliver_at)}}</li>
				</ul>

				<ul v-else>
					<li>{{order.delivery.information.address}}</li>
					<li>{{order.delivery.information.zipcode}} {{order.delivery.information.city}}</li>
					<li>Dato: {{order.delivery.deliver_at | moment('DD-MM-YYYY')}}</li>
                    <li>Tidspunkt: Kl. {{timeSpanTextFromDate(order.delivery.deliver_at)}}</li>
				</ul>

			</section>

			<section class="col-12 margin-b-50" v-if="!order.delivery.with_delivery">

                <h1 v-if="!order.delivery.information.address">Afhentning</h1>

				<ul>
					<li>Dato: {{order.delivery.deliver_at | moment('DD-MM-YYYY')}}</li>
                    <li v-if="!product.category_exceptions">Tidspunkt: Kl. {{timeSpanTextFromDate(order.delivery.deliver_at)}}</li>
                    <li v-else>Tidspunkt: Kl. {{product.time_slot_start}}:00 - {{product.time_slot_end}}:00</li>

                    <li v-if="deliveryPoint">Adresse: {{deliveryPoint}}</li>
                    <li v-else>Adresse: Kanalvej 52, 5000 Odense C</li>
				</ul>

			</section>

			<section class="col-12 margin-b-50 padding-b-50 border-b" v-if="order.with_delivery">

				<h1>Bemærkninger til levering</h1>
				<p>{{order.delivery.delivery_notes}}</p>

			</section>

			<section class="col-12 margin-b-50">

                <h1>{{product.title}} ({{order.details.quantity}} stk.) <span dusk="product-price">{{stripeAmount(productPrice).amount}},-</span></h1>

                <template v-for="selection in selectionsFiltered">
                    <h2>{{selection.title}}</h2>
                    <ul>
                        <template v-for="option in selection.options">
                            <li v-if="option.premium">{{option.title}} ({{option.quantity}} stk. á  {{stripeAmount(option.price).amount}},-) <span> {{stripeAmount(option.price).amount * option.quantity}},-</span></li>
                            <li v-else>{{option.title}} ({{option.quantity}} stk.)</li>
                        </template>
                        <li v-if="selectionHasPremiumSelected(selection)" class="premium-total">Total  <span>{{stripeAmount(selectionSelectedPremiumOptionsTotal(selection)).amount}},-</span></li>
                    </ul>
                </template>

			</section>

			<section class="col-12 margin-b-50" v-if="extraSelectionsFiltered.length > 0">

                <h1>Tilkøb </h1>

                <template v-for="selection in extraSelectionsFiltered">
                    <h2 v-if="selection.options.length > 0">{{selection.title}}</h2>
                    <ul>
                        <li v-for="option in selection.options">{{option.title}} ({{option.quantity}} stk. á {{stripeAmount(option.as_extra_price).amount}},-) <span> {{stripeAmount(option.as_extra_price).amount * option.quantity}},-</span></li>
                        <li class="premium-total" v-if="selection.options.length > 0">Total  <span>{{stripeAmount(selectionSelectedExtraOptionsTotal(selection)).amount}},-</span></li>
                    </ul>
                </template>

			</section>

            <section class="col-12 margin-b-50">

                <h1>Miljø- og emballageafgift <span>{{stripeAmount(packaging).amount}},-</span></h1>
                <p>({{stripeAmount(packaging_fee).amount}},- pr. stk.)</p>

            </section>

            <section class="col-12" v-if="energy_fee !== null">

                <h1>Energiafgift <span>{{stripeAmount(energy).amount}},-</span></h1>
                <p>({{stripeAmount(energy_fee).amount}},- pr. stk)</p>

            </section>

            <section class="col-12 margin-b-50 padding-b-50 border-b">
                <h1 v-if="!couponData">Total <span>{{stripeAmount(totalWithoutDeliveryFee).amount}},-</span></h1>
                <ul class="total" v-if="couponData">
                    <li>Total uden rabat <span>{{stripeAmount(totalWithoutDeliveryFee).amount}},-</span></li>
                    <li>Rabat  <template v-if="couponData.in_percent">- {{discount.text}}</template> <span>-{{stripeAmount(discount.totalWithoutDeliveryFee).amount}},-</span></li>
                </ul>
                <h1 v-if="couponData">Total <span>{{stripeAmount(totalWithoutDeliveryFee - discount.totalWithoutDeliveryFee).amount}},-</span></h1>

            </section>

            <section class="col-12 margin-b-50 padding-b-50 border-b" v-if="order.delivery.with_delivery">
                <h1 v-if="!order.delivery.information.address">Levering <span>{{stripeAmount(order.delivery.delivery_fee).amount}},-</span></h1>
                <h1 v-else>Levering på alternativ addresse <span>{{stripeAmount(order.delivery.delivery_fee).amount}},-</span></h1>
                <p v-if="couponData">Bemærk! Der gives ikke rabat på leveringsomkostninger</p>
            </section>

			<section class="col-12 margin-b-50 padding-b-50 border-b">

				<h1>Pris</h1>

                <ul class="total" v-if="!couponData">
                    <li>Samlet pris uden moms <span>{{stripeAmount(total).amountWithoutTaxes}},-</span></li>
                    <li>Moms <span>{{stripeAmount(total).taxes}},-</span></li>
                    <li>Samlet pris <span>{{stripeAmount(total).amount}},-</span></li>
                </ul>

                <ul class="total" v-else>
                    <li>Samlet pris uden moms <span>{{stripeAmount(discount.total).amountWithoutTaxes}},-</span></li>
                    <li>Moms <span>{{stripeAmount(discount.total).taxes}},-</span></li>
                    <li>Samlet pris <span>{{stripeAmount(discount.total).amount}},-</span></li>
                </ul>

			</section>

            <section class="row margin-b-50 padding-b-50">

                <coupon-field></coupon-field>

            </section>

		</section>

		<section class="col-12 flex--space">

			<router-link :to="{name:'make-order.custom.order.delivery'}">Tilbage</router-link>

			<button :class="{'disabled':!validated || isLoading}" class="btn--primary btn--sm primary--copper" href="#" @click.prevent="initiatePayment" :disabled="!validated || isLoading" dusk="approve-done">

				<span v-if="isLoading">

					<i class="spinner--light" v-if="isLoading"></i>
					Bearbejder

				</span>

				<span v-else>

					Opret bestilling

				</span>

			</button>

		</section>

		<ws-modal v-model="showTermsModal">

			<header class="modal__header">

				<h3>Handelsbetingelser</h3>

				<span class="close" @click.prevent="showTermsModal = false"><i class="fas fa-times"></i></span>

			</header>

			<section class="modal__content">

				<h4>Generelle oplysninger</h4>

				<ul>
				  <li>HMHJ Aps</li>
				  <li>Restaurationsvirksomhed</li>
				  <li>CVR.nr. 25246322</li>
				  <li>Sarumgårdsvej 1A</li>
				  <li>5290 Marslev</li>
				</ul>

				<ul>
				  <li><strong>Firma fysisk:</strong></li>
				  <li>Kanalvej 52</li>
				  <li>5000 Odense C</li>
				  <li>mh@nbhs.dk</li>
				  <li>Tlf. 66 12 05 10</li>
				  <li>Stiftet: 02.12.2013</li>
				</ul>

				<h4>Bestilling</h4>

                <p>For at kunne handle med HMHJ Aps skal du være fyldt 18 år. Du bekræfter dette ved accept af handelsebetingelserne.</p>

				<p>Du kan afgive bestillinger online 24 timer i døgnet.</p>

				<p>Når du har afgivet bestillingen og restauranten har modtaget din bestilling, sender vi
				straks en ordrebekræftelse til dig pr. e-mail, som indeholder dit ordrenummer.</p>

				<p>Ved køb af billetter / gavekort leveres der elektroniske billetter / gavekort til den e-mailadresse,
				  du indtaster i forbindelse med sit køb.</p>

				<p>Du skal selv printe dine billetter / medbringe dem elektronisk til arrangementet.</p>

				<p>Hvis du ikke kan finde billetten / gavekortet og/eller kvitteringen i din indbakke anbefaler vi, at du leder i sin spam-mappe.</p>

				<p>Har du ikke modtaget din billet / gavekort en time efter købet, opfordrer vi til, at du henvender dig til HMHJ Aps på restaurant@nbhs.dk.</p>


				<h4>Levering</h4>

				<p>Levering af Mad ud af huset fra HMHJ Aps anses for sket, når køber har fået varen udleveret. Alle bestillinger sendes med egene biler, hvis ikke andet er aftalt særskilt mellem køber og HMHJ Aps.</p>

				<p>Der gøres opmærksom på, at maden ikke leveres af en køkkenuddannet chauffør.</p>


				<h4>Leveringstidspunkt</h4>

				<p>Levering finder sted i tidsrummet mellem det aftalte seneste tidspunkt og halvanden time tidligere.</p>


				<h4>Priser og betaling</h4>

				<p>Betaling for din bestilling trækkes fra dit betalingskort med det samme.</p>

				<p>Den gældende pris er den pris, som på tidspunktet for bestillingen er angivet i den samlede
				  oversigt over ordren, inden du accepterer. Alle opgivne priser er i danske kroner (DKK) inkl. moms (25 %).</p>

				<p>Vi accepterer følgende betalingsmidler: VISA-Dankort, MasterCard, Maestro, VISA-Electron, JCB og American Express.</p>

				<p>Vi krypterer alle dine kortoplysninger, med den såkaldte SSL (Secure Socket Layer) protokol. Det betyder, at uvedkommende
				ikke kan aflæse dit kortnummer, eller andre informationer under transaktionen.</p>


				<h4>Køb af billetter til events</h4>

				<p>Billetten erstattes ikke ved bortkomst, så sørg for at gemme billetten i din indbakke.</p>

				<p>Billetten refunderes kun i forbindelse med aflysning.</p>

				<p>Billetten refunderes af HMHJ Aps, hvis det er i tilfælde af eventets aflysning. HMHJ Aps refunderer pengene så snart der foreligger en officiel meddelelse om aflysning.</p>

				<p>Evt. billet- og kortgebyr refunderes ikke.</p>

				<p>HMHJ Aps har intet ansvar i forbindelse med snyd, fejl og/eller kopiering af billetter.</p>


				<h4>Køb af Gavekort</h4>

				<p>Gavekort kan anvendes i 2 år fra udstedelsesdato og kan ikke fremdateres. Gavekortets udløbsdato vil altid fremgå af din faktura, samt på selve Gavekortet.</p>

				<p>Gavekort kan kun anvendes hos Restaurant Næsbyhoved Skov og udskrives kun i danske kroner.</p>

				<p>Et gavekort er et ihændehaverbevis og skal derfor betragtes som kontanter. Den person, der fremviser gavekortet, kan benytte dette til betaling. Der behøves ikke nogen yderligere identifikation af personen. Selvom du måtte have en bekræftelse fra gavegiveren, fra emballage eller kvittering, må vi desværre fastholde, at gavekortet alene har værdi for ihændehaver af gavekortet.</p>

				<p>Tabte, bortkomne eller udløbne gavekort erstattes ikke.</p>

				<p>Gavekortet kan indløses til kontanter på Restaurant Næsbyhoved Skov mod et gebyr på 50,00 DKK.</p>

				<p>Evt. kortgebyr refunderes ikke.</p>

				<p>HMHJ Aps har intet ansvar i forbindelse med snyd, fejl og/eller kopiering af gavekort.</p>


				<h4>Klager, fortrydelsesret og reklamation</h4>

				<p>Vi hører gerne fra dig, hvis du ikke er fuldt ud tilfreds med din bestilling, eller vores service. Hvis du har en klage,
				kan du sende denne til os, via e-mail til restaurant@nbhs.dk. Du er også meget velkommen til at kontakte os på telefon: 66 12 05 10.</p>

				<p>Hvis det ikke lykkes os at finde en løsning, kan du indgive en klage til Konkurrence- og Forbrugerstyrelsen, såfremt betingelserne herfor er opfyldt.</p>

				<p>Bemærk, at der ikke er fortrydelsesret for mad og drikkevarer. Købelovens almindelige regler om reklamation i tilfælde af mangelfulde varer, forsinkede varer,
				eller varer som ikke svarer til beskrivelsen, kan dog finde anvendelse.</p>

				<p>Køb af event billetter er ikke dækket af fortrydelsesret jf. Forbrugeraftaleloven §18 Stk. 2 nr. 12</p>


				<h4>Persondatapolitik og cookies</h4>

				<p>Vi anvender cookies på <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a>. En cookie er en lille tekstfil, der bliver sendt fra hjemmesiden og gemt lokalt på din harddisk.
				  På den måde kan hjemmesiden gøre dit besøg nemmere.</p>

				<p>De cookies, vi sender, er på ingen måde farlige for din computer. Vi bruger dem udelukkende til at give dig den bedste oplevelse.</p>

				<p>For at du kan indgå aftale med os, har vi brug for følgende oplysninger:</p>

				<ul>
				  <li>Navn</li>
				  <li>Adresse</li>
				  <li>Telefonnummer</li>
				  <li>E-mail adresse</li>
				</ul>

				<p>Vi foretager registreringen af dine personoplysninger med det formål, at kunne levere varen til dig.
				  Personoplysningerne registreres hos HMHJ ApS og opbevares i fem år, hvorefter oplysningerne slettes.</p>

				<p>Når der indsamles personoplysninger, via vores website, sikrer vi, at det altid sker ved afgivelse af dit udtrykkelige samtykke,
				  således at du er informeret om præcis, hvilke oplysninger der indsamles og hvorfor.</p>

				<p>Direktøren og den ansatte, som håndterer ekspeditionen for HMHJ ApS, har adgang til de oplysninger, der registreres om dig.</p>

				<p>Direktøren og den ansatte er naturligvis underlagt tavshedspligt - også i forhold til dine personoplysninger.</p>

				<p>Oplysninger afgivet til <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a> videregives, eller sælges ikke til tredjemand.</p>


				<h4>Logstatistik</h4>

				<p>Logstatistik bruges på <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a> og betyder, at et statistik-system opsamler information,
				  som kan give et statistisk billede af, hvor mange besøgende et website har haft, hvor de kommer fra, og på hvilken del af websitet dette forlades mm.</p>

				<p>På <a href="http://naesbyhovedskov.dk" target="_blank">http://naesbyhovedskov.dk</a> anvendes logstatistik med det formål, at optimere websitet og dets funktionalitet for dig som bruger. Vi ønsker, at dit besøg hos
				  os, skal være så relevant som muligt og vi vil gøre vort yderste for, at vise dig netop de områder, du helst vil se.</p>

				<p>Ligesom vi også anvender statistik-værktøj i forhold til de e-mails, du vil modtage hvis du tilvælger nyhedsbrev.</p>

			</section>

			<footer class="modal__footer">

				<a class="btn--primary btn--sm primary--copper" href="#" @click.prevent="showTermsModal = false">Ok, jeg er indforstået</a>

			</footer>

		</ws-modal>

	</section>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex';
    import totalCalculation from './../mixins/customTotalCalculation.js';
    import couponField from "../partials/couponField";
    import moment from "moment";
    export default {
        name: "approve",
        components:{
            couponField
        },
		data(){
            return {
				showTermsModal:false,
				acceptedTerms:false,
				wantsNewsletter:false,
				isLoading:false,
                cardNumber: null,
                cardExpiry: null,
                cvc: null,
                cardImages: {
                    visa: '/images/visa-icon.svg',
                    mastercard: '/images/mastercard-icon.svg',
                    discover: '/images/discover-icon.svg',
                    jcb: '/images/jcb-icon.svg',
                    dinersclub: '/images/diners-club-icon.svg',
                    amex: '/images/american-express-icon.svg',
                },
                cardNumberInFocus: false,
                cardNumberValidated: false,
                currentCard: '',
                cardExpiryInFocus: false,
                expirationValidated: false,
                cardCvcInFocus: false,
                cvcValidated: false,
                enteredFields: [],
                token:null,
			};
		},
		mixins:[totalCalculation],
        watch:{
            isLoading(newVal, oldVal){
                this.lockStepper(newVal);
            }
        },
		computed:{
			...mapGetters({
				order:'order',
				product:'product',
				packaging_fee:'packaging_fee',
                energy_fee:'energy_fee',
			}),
            information(){
                return this.order.information;
            },

            selectionsFiltered(){
                return this.product.selections.map(item => {
                    const selected = this.order.details.selections.find(selection => selection.selection_id == item.id);
                    return {
                        title: item.title,
                        options: selected.options.map(option => {
                            const optionData = item.options.find(optionItem => optionItem.id === option.id);
                            return {
                                title: optionData.title,
                                quantity: option.quantity,
                                price: optionData.price,
                                premium: option.premium,
                                packaging_price: option.packaging_price,
                            }
                        }),
                    }
                });
            },
            extraSelectionsFiltered(){
                return this.product.extra_selections.map(item => {
                    const selected = this.order.details.extra_selections.find(selection => selection.extra_selection_id == item.id);
                    if(selected.options.length > 0){
                        return {
                            id: item.id,
                            title: item.title,
                            options: selected.options.map(option => {
                                const optionData = item.options.find(optionItem => optionItem.id === option.id);
                                return {
                                    title: optionData.title,
                                    quantity: option.quantity,
                                    price: optionData.price,
                                    as_extra_price: optionData.as_extra_price,
                                    packaging_price: optionData.packaging_price,
                                }
                            }),
                        }
                    }

                    return null

                }).filter(item => item !== null);
            },
            deliveryPoint(){
			    if(this.order.delivery.hasOwnProperty('delivery_point')){
			        const point = this.product.delivery_points.find(item => item.id === this.order.delivery.delivery_point);

			        return `${point.address}, ${point.zipcode} ${point.city}`;
                }

			    return null
            },
            cardType() {
                return (this.currentCard != 'unknown' && this.currentCard != '') ? this.cardImages[this.currentCard] : false;
            },
            hasEnteredCardNumber() {
                return this.fieldHasBeenEntered('card-number');
            },
            hasEnteredExpiry() {
                return this.fieldHasBeenEntered('expiry');
            },
            hasEnteredCvc() {
                return this.fieldHasBeenEntered('cvc');

            },
            validated(){
			    return true;
            }
		},
		methods:{
            ...mapActions(['lockStepper']),
            unmountFields(){
                this.cardNumber.unmount('#card-number');
                this.cardNumber.removeEventListener('change');
                this.cardExpiry.unmount('#card-expiry');
                this.cardExpiry.removeEventListener('change');
                this.cardCvc.unmount('#card-cvc');
                this.cardCvc.removeEventListener('change');

                this.cardNumber = null;
                this.cardExpiry = null;
                this.cardCvc = null;
            },
            fieldHasBeenEntered(fieldName) {
                return this.enteredFields.indexOf(fieldName) > -1
            },
            enteredField(fieldName) {
                if (!this.fieldHasBeenEntered(fieldName)) {
                    return this.enteredFields.push(fieldName);
                }
            },
            initiatePayment(){
                if(this.isLoading){
                    return;
                }

                if(!this.validated){
                    return;
                }

                this.performTransaction();
            },
			performTransaction(){
			    let delivery = {
                    with_delivery:this.order.delivery.with_delivery,
                    deliver_at:this.order.delivery.deliver_at,
                    delivery_notes:this.order.delivery.delivery_notes,
				};

			    if(this.order.delivery.with_delivery && String(this.order.delivery.information.address).length > 0){
			        delivery.information = this.order.delivery.information;
				}

			    if(this.order.delivery.hasOwnProperty('delivery_point')){
			        delivery.delivery_point = this.order.delivery.delivery_point;
                }

				axios.post(`/api/admin/custom/order/make`, {
				    details: this.order.details,
					information: this.order.information,
					delivery: delivery,
					token: 'admin-made-order-token',
                    coupon: this.order.coupon,
					newsletter: false,
				}).then(response=>{
                    console.log(response);

				    this.$store.dispatch('setInvoiceLink', response.data.data);
				    this.$store.dispatch('completedPayment');
				    this.$router.replace({
						name:'make-order.custom.order.complete'
					});
					this.isLoading = false;

				}).catch(error => {
					console.error(error);
					this.$store.dispatch('setCardError', error.response.data.errors.code);
                    this.$router.replace({
                        name:'make-order.custom.order.failed'
                    });
                    this.isLoading = false;
                })

			},
            timeSpanTextFromDate(date) {
                return `${moment(date).format('H:mm')} - ${moment(date).add(1 , 'hour').format('H:mm')}`;
            },
		},
        mounted() {
            console.log('mounted');

            if (this.information.city) {
                this.city = this.information.city;
            }

            let base = {
                fontFamily: "'Work Sans', sans-serif",
                fontSize: '16px',
                fontWeight: '300',
                color: '#4a4847',
                '::placeholder': {
                    color: "#bcb9b8",
                }
            };
        },
    }
</script>

<style scoped>

</style>
